'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_jsonCodecs$package$$anon$111(ps$76) {
  this.a6I = null;
  this.a6I = ps$76;
}
export { $c_Lmealorama_jsonCodecs$package$$anon$111 as $c_Lmealorama_jsonCodecs$package$$anon$111 };
$p = $c_Lmealorama_jsonCodecs$package$$anon$111.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_jsonCodecs$package$$anon$111;
/** @constructor */
function $h_Lmealorama_jsonCodecs$package$$anon$111() {
}
export { $h_Lmealorama_jsonCodecs$package$$anon$111 as $h_Lmealorama_jsonCodecs$package$$anon$111 };
$h_Lmealorama_jsonCodecs$package$$anon$111.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return "";
});
$p.q = (function() {
  return this.a6I.a.length;
});
$p.g = (function(i) {
  return this.a6I.a[i];
});
var $d_Lmealorama_jsonCodecs$package$$anon$111 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_jsonCodecs$package$$anon$111, "mealorama.jsonCodecs$package$$anon$111", ({
  Il: 1,
  b: 1,
  c: 1
}));
export { $d_Lmealorama_jsonCodecs$package$$anon$111 as $d_Lmealorama_jsonCodecs$package$$anon$111 };
//# sourceMappingURL=mealorama.json-Codecs$package$$anon$111.js.map
